export default "__VITE_ASSET__pYof_q9$__"